/**
 * 블로그 상세 — "이 글과 함께 보면 좋은 정보" (도구·가이드 + 글에 언급된 지역 랜딩).
 *
 * 영구지침: docs/develop/seo/blog-internal-links-spec.md
 * 글 데이터만으로 계산하므로 SSR HTML 에 <a href> 로 그대로 포함된다.
 */
import { Link } from 'react-router-dom'
import { regionLinksFor, toolLinksFor, type RelatedLink } from '@/lib/blogRelatedLinks'

interface Props {
  post: {
    category: string
    title: string
    keywords: string[] | null
    content: string
  }
}

function LinkChips({ links }: { links: RelatedLink[] }) {
  return (
    <ul className="mt-2 flex flex-wrap gap-2">
      {links.map((link) => (
        <li key={link.to}>
          <Link
            to={link.to}
            className="inline-flex rounded-full border border-gray-200 bg-white px-3 py-1.5 text-sm text-gray-700 hover:border-cb-primary hover:text-cb-primary"
          >
            {link.label}
          </Link>
        </li>
      ))}
    </ul>
  )
}

export default function BlogRelatedLinks({ post }: Props) {
  const tools = toolLinksFor(post.category)
  const regions = regionLinksFor(post)
  if (tools.length === 0 && regions.length === 0) return null

  return (
    <section aria-labelledby="blog-related-links" className="mt-10 rounded-2xl border border-gray-200 bg-gray-50 p-5">
      <h2 id="blog-related-links" className="text-base font-bold text-gray-900">
        이 글과 함께 보면 좋은 정보
      </h2>
      {tools.length > 0 && (
        <div className="mt-3">
          <p className="text-xs font-semibold text-gray-500">도구·가이드</p>
          <LinkChips links={tools} />
        </div>
      )}
      {regions.length > 0 && (
        <div className="mt-4">
          <p className="text-xs font-semibold text-gray-500">지역별 시설</p>
          <LinkChips links={regions} />
        </div>
      )}
    </section>
  )
}
